import { motion } from "framer-motion";

const BrandWatermark = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none select-none z-0">
      {/* Diagonal watermark text */}
      <div className="absolute inset-0 opacity-[0.02] -rotate-12 scale-150">
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i}
            className="whitespace-nowrap text-[80px] font-black text-white tracking-[0.2em] leading-[1.5]"
            initial={{ x: i % 2 === 0 ? -100 : 0 }}
          >
            GLOBAL METAFORA APP &nbsp;&nbsp; GLOBAL METAFORA APP &nbsp;&nbsp; GLOBAL METAFORA APP &nbsp;&nbsp; GLOBAL METAFORA APP
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default BrandWatermark;
